/** biome-ignore-all lint/style/useNamingConvention: camel case */
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {uploadPhoto} from '~/ViewInvitation/api/photos';
import {
  CONVERT_TO_FAILED,
  MARK_UPLOAD_SUCCESS,
  MARK_UPLOAD_UPLOADING,
  PHOTO_FAILED_REASON_OTHER,
} from '~/ViewInvitation/reducers/constants';
import {selectFeaturedPhoto} from '~/ViewInvitation/selectors/photos';
import {getPhotoSize} from '~/ViewInvitation/utils/photos';

export const usePhotoUpload = ({eventId, guestId, collection}) => {
  const dispatch = useDispatch();
  const featuredPhoto = useSelector(selectFeaturedPhoto);

  const markPhotoSuccess = useCallback(
    (photo, id) => {
      dispatch({
        type: MARK_UPLOAD_SUCCESS,
        payload: {
          id: photo.id,
          photoId: id,
          collection,
        },
      });
    },
    [dispatch, collection]
  );

  const markUploading = useCallback(
    (photo) => {
      dispatch({
        type: MARK_UPLOAD_UPLOADING,
        payload: {
          id: photo.id,
          collection,
        },
      });
    },
    [dispatch, collection]
  );

  const failPhoto = useCallback(
    (photo, reason) => {
      dispatch({
        type: CONVERT_TO_FAILED,
        payload: {
          id: photo.id,
          reason,
          collection,
        },
      });
    },
    [dispatch, collection]
  );

  const doUploadPhoto = useCallback(
    async (photo, isHostModule) => {
      try {
        markUploading(photo);
        const size = await getPhotoSize(photo);
        const photoId = await uploadPhoto({eventId, guestId, photo, ...size, isHostModule});
        if (photoId) {
          markPhotoSuccess(photo, photoId);
          const isFeatured = photo.id === featuredPhoto?.id;
          return {...photo, photo_id: photoId, isFeatured};
        }
        failPhoto(photo, PHOTO_FAILED_REASON_OTHER);
        return null;
      } catch (e) {
        evite.error('Failed to upload to gcs', e);
        failPhoto(photo, e.message || PHOTO_FAILED_REASON_OTHER);
        return null;
      }
    },
    [eventId, guestId, markUploading, markPhotoSuccess, failPhoto, featuredPhoto]
  );

  return {doUploadPhoto};
};
